import React from "react";
import Icon from "../common/Icon/Icon";
import { convertToSelectedTimezoneFormatted } from "../../utils/timeZoneUtil";
import { useSelector } from "react-redux";
// Internal Dependencies

// Define the types for the version data



export interface ChangeLogItemDTO {
  title: string;
  changeLogItemId: number;
}

export interface ChangeLogDTO {
  version: string;
  createdOn: string; 
  changeLogId: number;
  deployedDateTime: string; 
}

interface BlockQuoteProps {
  versionData: {
    changeLogDTO: ChangeLogDTO;
    changeLogItemDTOs: ChangeLogItemDTO[];
  }[];
  searchTerm?: string; // Optional search term for highlighting
}

const BlockQuote: React.FC<BlockQuoteProps> = ({ versionData, searchTerm }) => {
  const timeZone = useSelector((state: any) => state.sessionData.sessionScope.timeZone || "Asia/Kolkata");
  const highlightText = (text: string) => {
    if (!searchTerm) return text;
    const regex = new RegExp(`(${searchTerm})`, "gi");
    return text.split(regex).map((part, index) =>
      regex.test(part) ? (
        <span key={index} className="highlight">
          {part}
        </span>
      ) : (
        part
      )
    );
  };
  return (
    <blockquote id="changeLogList">
      <div className="ver-list">
        {versionData &&
          versionData.map((item, index) => (
            <React.Fragment key={index}>
              <h5 id={item.changeLogDTO.version}>
                {highlightText("Version " + item.changeLogDTO.version)}
                <span className="float-right font-weight-normal m--regular-font-size-lg1">
                  <Icon name="calendar" aria-hidden="true" />
                  {convertToSelectedTimezoneFormatted(item.changeLogDTO.deployedDateTime,timeZone)}
                </span>
              </h5>
              <ul>
                {item?.changeLogItemDTOs?.map((item, index) => (
                  <li key={index}>{highlightText(item.title)}</li>
                ))}
              </ul>
            </React.Fragment>
          ))}
      </div>
    </blockquote>
  );
};

export default BlockQuote;
